export async function waitUntilNotNull<T> (
  getter: () => T | null | undefined,
  interval = 50
): Promise<T> {
  return await new Promise((resolve) => {
    const check = () => {
      const value = getter()
      if (value != null) {
        resolve(value)
      } else {
        setTimeout(check, interval)
      }
    }
    check()
  })
}
